import { render, staticRenderFns } from "./ContentViewSettingsGeneral.vue?vue&type=template&id=fabf71c0&scoped=true&"
import script from "./ContentViewSettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsGeneral.vue?vue&type=style&index=0&id=fabf71c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabf71c0",
  null
  
)

export default component.exports